// Module
var code = " <div class=\"container-xxl position-relative\"> <span class=\"close-search d-none\"> <div id=\"{{id}}-clearFilters\"></div> </span> <div id=\"landing-search-hits\"></div> </div>";
// Exports
export default code;